import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {
  shouldUploadDocument: boolean;
  updateAddressParams: {
    patientId: string;
    phone: string;
    email: string;
    streetAddress: string;
    city: string;
    state: string;
    postalCode: string;
  };
  error: boolean;
  // building: boolean;
} = {
  shouldUploadDocument: false,
  updateAddressParams: {
    patientId: "",
    phone: "",
    email: "",
    streetAddress: "",
    city: "",
    state: "",
    postalCode: "",
  },
  error: false,
  // building: false,
};

const updateAddress = (state = initialState, action) => {
  console.log([action.paramName], [action.paramValue]);
  const updatedAddressParam = {
    [action.paramName]: action.paramValue.trim(),
  };
  const updatedParams = updateObject(
    state["updateAddressParams"],
    updatedAddressParam
  );
  const updatedState = {
    updateAddressParams: updatedParams,
    // building: true,
  };
  return updateObject(state, updatedState);
};
const updatedAddressReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_UPDATED_ADDRESS_PARAM:
      return updateAddress(state, action);
    case actionTypes.SHOULD_UPLOAD_DOCUMENT:
      //console.log("action.shouldUpload",action.shouldUpload)
      //console.log("update shouldUpload",updateObject(state, { shouldUploadDocument: action.shouldUpload }))
      return updateObject(state, { shouldUploadDocument: action.shouldUpload });
    case actionTypes.RESET_UPDATED_ADDRESS_PARAM:
      return initialState;
    default:
      return state;
  }
};
export default updatedAddressReducer;
